
import { useEffect,useState } from 'react';
import { getGovScanResultItemPdf } from '../../util/apiGovScan';
import { Box,SkeletonCircle,SkeletonText,Alert,AlertIcon,AlertTitle,AlertDescription } from '@chakra-ui/react';


const PdfViewer=({id})=>{
    const [state,setState]=useState({path:"",pdfIsLoaded:false});
    const [err,setErr]=useState("");

    useEffect(()=>{
        const fetchPath=async()=>{
            try {
                const res=await getGovScanResultItemPdf(id);
                
                if (res.status===200) {
                    //setState({...state,path:res.res.path,pdfIsLoaded:true});
                    setState(s => ({ ...s, path: res.res.path, pdfIsLoaded: true }));
                } else {
                    //setState({...state,pdfIsLoaded:true})
                    setErr(s=>({...s,pdfIsLoaded:true}));
                    throw new Error(res.message);
                }
            } catch (error) {
                setErr(error.message)
            }
        }

        fetchPath();
    },[id])

    const showSkeleton=()=>{
        if (!state.pdfIsLoaded) {
            return (
                <>
                    <SkeletonCircle size={10}/>
                    <SkeletonText mt='4' noOfLines={8} spacing='4' skeletonHeight='2' />
                </>
            )
        }
    }
    const showPdf=()=>{
        if (state.path!=="") {
            return (
                <>
                    <iframe
                    id="inlineDocPdf"
                    title="Dokument"
                    width="100%"
                    height="700"
                    src={state.path}
                    >
                    </iframe>
                </>
            )
        }
    }
const showErr=()=>{
    if (err!=="") {
        return (
            <Alert status='error'>
                <AlertIcon />
                <AlertTitle>Greška kod prikaza dokumenta</AlertTitle>
                <AlertDescription>Dokument se više ne nalazi u arhivi.</AlertDescription>
            </Alert>
        )
    }
}
    return (
        <Box>
            {showSkeleton()}
            {showPdf()}
            {showErr()}
        </Box>
    )

}

export default PdfViewer;